export default __webpack_public_path__ + "static/media/woocommerce-plain.19f70b09.svg";